module.exports = __webpack_public_path__ + "img/ezDealerImage.6d4e03e9.png";